<!--Componente que muestra los pasos de ¿Cómo funciona? en la vista de How It's works (¿Cómo funciona?)-->
<template>
    <v-row justify="center" class="text-center fill-height" >
        <v-col cols="12">
            <h2 class="display-1 font-weight-bold text-uppercase mb-xl-2">
                {{ data.title }}:
            </h2>
            <h3 class="display-1 mb-xl-5">{{ data.subtitle }}</h3>
            <p v-if="data.hasOwnProperty('description')">
                {{ data.description }}
            </p>
            <p v-else v-html="data.html"></p>
        </v-col>
        <v-col cols="12" xl="10" class="mb-xl-5">
            <v-icon color="accent" v-bind:style="getSize">{{ data.icon }}</v-icon>
        </v-col>
    </v-row>
</template>
<script>
export default {
    /* 
    PROPIEDADES DEL COMPONENTE
    - data - Objeto con las siguientes propiedades:
        1. title: String - Requerido -- Título de la tarjeta
        2. subtitle: String - Requerido -- Subtitulo de la tarjeta
        3. description: String - Opcional -- Texto de la tarjeta
        4. html: String - Opcional -- Texto de la tarjeta con formato html
        5. icon: String - Requerido - Texto con el nombre del ícono que se desea mostrar, ya sea de Material Design ( EJ. arrow_right_alt ) o Font Awesome ( EJ. fas fa-arrow-right )
       
    */
    props:{
        data: { type:Object, required: true }
    },
    computed:{
        getSize(){
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 'font-size:3.5em'
                case 'sm': return 'font-size:3.5em'
                case 'md': return 'font-size:4em'
                case 'lg': return 'font-size:5em'
                case 'xl': return 'font-size:6em'
            }
        }
    }
}
</script>
